import axios from 'axios'
import { ProcessInfo } from '@aicoding/micro-bridge'

const http = axios.create({
  baseURL: 'https://asset-sit.haier.net/assect-center/',
})

// 为所有请求添加 access-token header
http.interceptors.request.use((config) => {
  const token = localStorage.getItem('haier-user-center-access-token')
  if (token && config.headers) {
    config.headers['access-token'] = token
  }
  return config
})

interface IResponse<T> {
  code: number
  success: boolean
  message: string
  data: T
}

interface ITriggerWorkflow {
  assetCode: string
  assetVersionCode: string
}
export const triggerWorkflow = async (input: ITriggerWorkflow) => {
  console.log('请求相关菜单接口');
  const response = await http.post<IResponse<ProcessInfo>>('/api/v1/open/workflow/instances/trigger', input)
  return response.data.data
}
